import React, { FC } from 'react';
import { Formik, FormikProps, Form } from 'formik';
import { Grid, TextField, Button, makeStyles } from '@material-ui/core';
import * as Yup from 'yup';
import type { ExtraInput } from './types';

const extraSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  total: Yup.number().required('Required')
});

interface Props {
  initialValues?: ExtraInput;
  submitLabel?: string;
  onSubmit: (values: ExtraInput) => void;
  onSuccess?: () => void;
}

const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(2)
  }
}));

const defaultValues = {
  name: '',
  total: 0
};

const ExtraForm: FC<Props> = ({ onSubmit, onSuccess, initialValues = defaultValues, submitLabel = 'Add extra' }) => {
  const { input, button } = useStyles();

  const handleSubmit = (values: ExtraInput) => {
    const { id, ...rest } = values;
    onSubmit(rest);
    onSuccess?.();
  };

  return (
    <Formik enableReinitialize={true} initialValues={initialValues} onSubmit={handleSubmit} validationSchema={extraSchema}>
      {({ errors, touched, handleChange, handleBlur, values }: FormikProps<ExtraInput>) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                id="outlined-name"
                label="Name"
                name="name"
                value={values.name}
                variant="outlined"
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!errors.name && !!touched.name}
                helperText={!!errors.name && !!touched.name && errors.name}
                margin="normal"
                className={input}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="outlined-name"
                label="Net total"
                name="total"
                value={values.total}
                onChange={handleChange}
                variant="outlined"
                onBlur={handleBlur}
                error={!!errors.total && !!touched.total}
                helperText={!!errors.total && !!touched.total && errors.total}
                margin="normal"
                className={input}
                type="number"
                onWheel={(e) => {
                  // Prevent the input value change
                  (e.target as HTMLInputElement).blur();;
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-multiline-static"
                variant="outlined"
                label="Notes"
                name="notes"
                value={values.notes}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{ width: '100%' }}
                multiline
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" className={button} type="submit" color="primary">
                {submitLabel}
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ExtraForm;
